import { useEffect, useState } from "react";
import { fetchStores, downloadStoresExcel } from "../Api/ViewStoreMaster";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewStoreMaster = () => {
  const [stores, setStores] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadStores = async () => {
      try {
        const data = await fetchStores();
        setStores(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Stores`);
      }
    };

    loadStores();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadStoresExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Stores_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Stores data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div>
          <Container className="list-container">
            <div className="header-background">
              <h2 className="header-list-title">View Stores</h2>
              <Button className="gradient-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || stores.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {stores.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Store Code</th>
                    <th>Store Name</th>
                    <th>Office Code</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {stores.map((store, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{store.code}</td>
                      <td>{store.name}</td>
                      <td>{store.officeCode}</td>
                      <td>
                        {moment(store.createdOnDate).format('L')} at {store.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{store.createdBy}</td>
                      <td>
                        {store.changedOnDate ? 
                          `${moment(store.changedOnDate).format('L')} at ${store.changedOnTime?.substring(0, 8)}` : 
                          'N/A'}
                      </td>
                      <td>{store.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No stores found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewStoreMaster;